import { Flex, IconEditLine, IconTrashLine } from "@instructure/ui";
import { IconButton } from "@instructure/ui-buttons";
import { t } from "i18next";
import React, { useContext, useState } from "react";
import { CycleTypeService } from "../../../services/CyclesService";
import { Card } from "../../Card";
import { ERROR, useNotification } from "../../CustomHooks/NotificationProvider";
import { DialogYesNo } from "../../DialogYesNo";
import { CycleContext } from "../CyclesAndGoals";
import { CycleTypeEditModal } from "./CycleTypeEditModal";

const CycleTypeEntry = ({ cycleType }) => {
  const { setCycleTypes } = useContext(CycleContext);
  const showNotification = useNotification();
  const [openEdit, setOpenEdit] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);

  async function deleteCycleType(cycleType) {
    try {
      await CycleTypeService.deleteCycleType(cycleType.id);
      setCycleTypes((prevTypes) =>
        prevTypes.filter((type) => type.id !== cycleType.id)
      );
      setConfirmDelete(false);
      showNotification(
        t("notifications.general.deleteSuccess", {
          obj: t("cyclesAndGoals.typeSelect.label"),
        })
      );
    } catch {
      showNotification(
        t("notifications.general.deleteError", {
          obj: t("cyclesAndGoals.typeSelect.label"),
        }),
        ERROR
      );
    }
  }

  return (
    <Card
      style={{
        backgroundColor: "#F2F8FA",
        border: "1px solid #ccc",
        borderRadius: "10px",
        padding: "5px 15px",
        marginBottom: "0.75rem",
      }}
    >
      <Flex gap="small">
        <Flex.Item shouldGrow shouldShrink>
          <Flex direction="column">
            <Flex.Item>
              <span style={{ color: " #0D323F" }}>{cycleType.name}</span>
            </Flex.Item>
            <Flex.Item>
              <span style={{ fontSize: "0.9em", color: "#156380" }}>
                {t("cyclesAndGoals.cycleType.durationEvery")}{" "}
                {cycleType.duration}
              </span>
            </Flex.Item>
          </Flex>
        </Flex.Item>
        <Flex.Item>
          <IconButton
            renderIcon={IconEditLine}
            screenReaderLabel={`${t("academicHierarchy.edit")} ${cycleType.name}`}
            onClick={() => setOpenEdit(true)}
          />
        </Flex.Item>
        <Flex.Item>
          <IconButton
            renderIcon={IconTrashLine}
            screenReaderLabel={`${t("evidence.delete")} ${cycleType.name}`}
            onClick={() => setConfirmDelete(true)}
          />
        </Flex.Item>
      </Flex>
      <DialogYesNo
        message={t("cyclesAndGoals.cycleType.deleteCycleType")}
        openStatus={confirmDelete}
        onClickNo={() => setConfirmDelete(false)}
        onClickYes={() => deleteCycleType(cycleType)}
      />
      <CycleTypeEditModal
        open={openEdit}
        setOpen={setOpenEdit}
        cycleType={cycleType}
      />
    </Card>
  );
};

export default CycleTypeEntry;
